import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDistance } from '../../utils/geo';

/** "350 m" / "1.2 km", translated. */
export default function DistanceText({ meters, className = '' }: { meters: number; className?: string }) {
  const { t } = useTranslation();
  const { unit, value } = formatDistance(meters);
  return <span className={className}>{t(`directory.distance.${unit}`, { value })}</span>;
}
